import { DeskTop, Laptop1, Laptop2, Laptop3, LaptopOne, Monitor2, Mouse1, Mouse2, Mouse3, MouseOne } from "../../assets/Home";
export const serviceData = [
  {
    id: "BS0002",
    placedDate: "2 Sept 2024",
    invoiceNo: "INV-001",
    desc:"inprogress",

    person_name: "Rahul Sharma",
    email:"rahulsharma12@gnmail.com",
    contact_number: "+91 9876543210",
    pickup_required: "Yes",
    preferred_date: "2025-08-05",
    pickupDate: "2025-08-04",
    preferred_time_slot: "10:00 AM - 12:00 PM",
    notes: "Please handle carefully",
    client_status: "",
    acceptReason:"",
    rejectReasonByManager:"",
    rejectReasonByClient:"",

    status:"Estimation received",
    timeline: [
      {
        date: "2 Sept 2024",
        time: "10:00 AM",
        status: "Request Received",
        completed: true,
      },
      {
        date: "2 Sept 2024",
        time: "01:00 PM",
        status: "Request accepted",
        completed: true,
      },
       {
        date: "2 Sept 2024",
        time: "02:00 PM",
        status: "Estimation received",
        completed: true,
      },
      // {
      //   date: "2 Sept 2024",
      //   time: "2:10 PM",
      //   status: "Person assigned for pickup",
      //   completed: true,
      // },
    ],
    address: {
    flat_no: "1201",
    building_block: "A",
    floor: "12th",
    building_name: "Skyline Towers",
    street_name: "Linking Road",
    landmark: "Near Infinity Mall",
    city: "Mumbai",
    state: "Maharashtra",
    pincode: "400053"
  },
  devices: [
    {
      brand_name: "Dell",
      model_number: "XPS 13 9310",
      number_of_devices: 2,
      problem_description: "Screen flickering after startup",
      services: "Screen Replacement",
      device_type: "Laptop",
      issue_start_date: "2025-08-15",
      warranty_status: "no",
      issue_photos: [Laptop1, Laptop2, Laptop3,Laptop1],
    },
    {
      brand_name: "HP",
      model_number: "Pavilion 15",
      number_of_devices: 1,
      problem_description: "Screen flickering after startup",
      services: "Screen Replacement",
      device_type: "Laptop",
      issue_start_date: "2025-08-01",
      warranty_status: "not sure",
      issue_photos: [Laptop1, Laptop2, Laptop3,Laptop1],
    },
    {
      brand_name: "Lenovo",
      model_number: "ThinkPad X1",
      number_of_devices: 3,
      problem_description: "Screen flickering after startup",
      services: "Screen Replacement",
      device_type: "Laptop",
      issue_start_date: "2025-08-08",
      warranty_status: "yes",
      issue_photos: [Laptop1, Laptop2, Laptop3,Laptop1],
    }
  ]
  },
  {
    id: 2,
    placedDate: "5 Sept 2024",
    invoiceNo: "INV-002",
    desc:"inprogress",
    person_name: "Sneha Patel",
    email:"snehapatel@gmil.com",
    contact_number: "+91 9123456780",
    pickup_required: "No",
    preferred_date: "2025-08-06",
    pickupDate: "2025-08-01",
    preferred_time_slot: "2:00 PM - 4:00 PM",
    notes: "Customer prefers weekend visit",
    client_status: "approved",
    reason: "Multiple device service request approved as per diagnosis",
    acceptReason:"Multiple device service request approved as per diagnosis",
    rejectReasonByManager:"",
    rejectReasonByClient:"",
    status:"Request accepted",
    timeline: [
      {
        date: "5 Sept 2024",
        time: "10:30 AM",
        status: "Request Received",
        completed: true,
      },
      {
        date: "5 Sept 2024",
        time: "01:00 PM",
        status: "Request accepted",
        completed: true,
      },
      
    ],
      address: {
    flat_no: "302",
    building_block: "B",
    floor: "3rd",
    building_name: "Sunshine Residency",
    street_name: "MG Road",
    landmark: "Near City Mall",
    city: "Pune",
    state: "Maharashtra",
    pincode: "411001"
  },
  devices: [
    {
      brand_name: "Samsung",
      model_number: "Galaxy S21",
      number_of_devices: 3,
      problem_description: "Battery drains quickly",
      services: "Phone Battery",
      device_type: "Smartphone",
      issue_start_date: "2025-08-03",
      warranty_status: "no",
      issue_photos: [Laptop1, Laptop2, Laptop3,Laptop1],
    },
    {
      brand_name: "Dell",
      model_number: "Inspiron 15",
      number_of_devices: 1,
      problem_description: "Screen flickering",
      services: "Screen Replacement",
      device_type: "Laptop",
      issue_start_date: "2025-08-10",
      warranty_status: "not sure",
      issue_photos: [Laptop1, Laptop2, Laptop3,Laptop1],
    },
    {
      brand_name: "Apple",
      model_number: "iPad Pro",
      number_of_devices: 2,
      problem_description: "Charging port not working",
      services: "Charging Port Repair",
      device_type: "Tablet",
      warranty_status: "no",
      issue_start_date:"2025-08-20",
      issue_photos: [Laptop1, Laptop2, Laptop3,Laptop1],
    }
  ]
  },
  {
    id: 3,
    placedDate: "10 Sept 2024",
    invoiceNo: "INV-003",
    person_name: "Anil Kumar",
    contact_number: "+91 9001122334",
    pickup_required: "Yes",
    preferred_date: "2025-08-07",
    pickupDate: "2025-08-06",
    preferred_time_slot: "9:00 AM - 11:00 AM",
    notes: "Bring replacement parts",
    client_status: "rejected",
    //reason: "Rejected due to unavailable parts at service center",
    acceptReason:"",
    rejectReasonByManager:"",
    rejectReasonByClient:"Request rejected due to high repair cost estimation",
    status:"Estimation received",
    desc:"inprogress",
    timeline: [
      {
        date: "10 Sept 2024",
        time: "11:00 AM",
        status: "Request Received",
        completed: true,
      },
      {
        date: "10 Sept 2024",
        time: "01:00 PM",
        status: "Request accepted",
        completed: true,
      },
      {
        date: "10 Sept 2024",
        time: "02:00 PM",
        status: "Estimation received",
        completed: true,
      },
      {
        date: "10 Sept 2024",
        time: "03:00 PM",
        status: "Estimation rejected by you",
        completed: true,
      },
      // {
      //   date: "10 Sept 2024",
      //   time: "03:00 PM",
      //   status: "Updated estimation received",
      //   completed: true,
      // },
      // {
      //   date: "10 Sept 2024",
      //   time: "02:00 PM",
      //   status: "Estimation received",
      //   completed: true,
      // },
      // {
      //   date: "10 Sept 2024",
      //   time: "3:00 PM",
      //   status: "Person assigned for pickup",
      //   completed: true,
      // },
      // {
      //   date: "11 Sept 2024",
      //   time: "9:00 AM",
      //   status: "Pickup completed",
      //   completed: true,
      // },
      // {
      //   date: "12 Sept 2024",
      //   time: "1:30 PM",
      //   status: "Repair process started",
      //   completed: true,
      // },
    ],
    address: {
    flat_no: "1201",
    building_block: "A",
    floor: "12th",
    building_name: "Skyline Towers",
    street_name: "Linking Road",
    landmark: "Near Infinity Mall",
    city: "Mumbai",
    state: "Maharashtra",
    pincode: "400053"
  },
  devices: [
    {
      brand_name: "HP",
      model_number: "LaserJet 1020",
      number_of_devices: 4,
      problem_description: "Paper getting jammed",
      services: "Printer Issue",
      device_type: "Printer",
      issue_start_date: "2025-08-02",
      warranty_status: "no",
      issue_photos: [MouseOne, Monitor2, Mouse3],
    },
    {
      brand_name: "Canon",
      model_number: "PIXMA G3010",
      number_of_devices: 1,
      problem_description: "Paper getting jammed",
      services: "Printer Issue",
      device_type: "Printer",
      issue_start_date: "2025-08-10",
      warranty_status: "not sure",
      issue_photos: [MouseOne, Monitor2, Mouse3],
    }
  ]
  },
  {
    id: 4,
    placedDate: "09 October 2024",
    status: "Estimation received",
    desc:"inprogress",
    invoiceNo: "INV-004",
    person_name: "Priya Singh",
    contact_number: "+91 9812345678",  
    pickup_required: "Yes",
    preferred_date: "2025-08-08",
    pickupDate: "2025-08-07",
    preferred_time_slot: "3:00 PM - 5:00 PM",
    notes: "Requires urgent service",
    client_status: "pending",
    reason: "",
    acceptReason:"",
    rejectReasonByManager:"Our Service cost is fixed, We cannot modify it.",
    rejectReasonByClient:"Request rejected due to high repair cost estimation",
    timeline: [
       {
        date: "10 Sept 2024",
        time: "11:00 AM",
        status: "Request Received",
        completed: true,
      },
      {
        date: "10 Sept 2024",
        time: "01:00 PM",
        status: "Request accepted",
        completed: true,
      },
       {
        date: "10 Sept 2024",
        time: "02:00 PM",
        status: "Estimation received",
        completed: true,
      },
      {
        date: "10 Sept 2024",
        time: "03:00 PM",
        status: "Estimation rejected by you",
        completed: true,
      },
      {
        date: "11 Sept 2024",
        time: "04:00 PM",
        status: "Service request rejected",
        completed: true,
      },
      // {
      //   date: "2 Sept 2024",
      //   time: "10:00 AM",
      //   status: "Pickup requested (Request created)",
      //   completed: true,
      // },
      // {
      //   date: "2 Sept 2024",
      //   time: "2:10 PM",
      //   status: "Person assigned for pickup",
      //   completed: true,
      // },
      // {
      //   date: "3 Sept 2024",
      //   time: "5:30 PM",
      //   status: "Pickup completed",
      //   completed: true,
      // },
      // {
      //   date: "4 Sept 2024",
      //   time: "3:10 PM",
      //   status: "Repair started",
      //   completed: true,
      // },
      // {
      //   date: "5 Sept 2024",
      //   time: "1:45 PM",
      //   status: "Repair completed",
      //   completed: true,
      // },
      // {
      //   date: "6 Sept 2024",
      //   time: "4:00 PM",
      //   status: "Out for Delivery",
      //   completed: true,
      // },
      
    ],
    address: {
    flat_no: "12A",
    building_block: "C",
    floor: "2nd",
    building_name: "Green Heights",
    street_name: "Indiranagar",
    landmark: "Near Metro Station",
    city: "Bangalore",
    state: "Karnataka",
    pincode: "560038"
  },
  devices: [
    {
      brand_name: "LG",
      model_number: "AC1234",
      number_of_devices: 1,
      problem_description: "Not cooling properly",
      services: "AC Maintenance",
      device_type: "Air Conditioner",
      issue_start_date: "2025-08-08",
      warranty_status: "no",
      issue_photos: [DeskTop, LaptopOne, Monitor2]
    },
    {
      brand_name: "Samsung",
      model_number: "AC5678",
      number_of_devices: 1,
      problem_description: "Remote not working",
      services: "Remote Replacement",
      device_type: "Air Conditioner",
      issue_start_date: "2025-08-10",
      warranty_status: "yes",
      issue_photos: [DeskTop, LaptopOne, Monitor2]
    }
  ]
  },
  {
    id: 5,
    placedDate: "09 October 2024",
    status: "Cancelled",
    desc:"cancelled",
    invoiceNo: "INV-005",
    person_name: "Karan Mehta",
  contact_number: "+91 9090909090",
  pickup_required: "No",
  preferred_date: "2025-08-09",
  pickupDate: "",
  preferred_time_slot: "5:00 PM - 7:00 PM",
  notes: "Customer will be available late",
  client_status: "",
  acceptReason:"",
  rejectReasonByManager:"",
  rejectReasonByClient:"",
    timeline: [
      {
        date: "2 Sept 2024",
        time: "10:00 AM",
        status: "Request Received",
        completed: true,
      },
      {
        date: "2 Sept 2024",
        time: "1:00 PM",
        status: "Request Cancelled by user",
        completed: true,
      },
    ],
      address: {
    flat_no: "504",
    building_block: "A",
    floor: "5th",
    building_name: "Skyline Apartments",
    street_name: "Banjara Hills",
    landmark: "Near City Center Mall",
    city: "Hyderabad",
    state: "Telangana",
    pincode: "500034"
  },
  devices: [
    {
      brand_name: "Sony",
      model_number: "Bravia X900H",
      number_of_devices: 1,
      problem_description: "No sound from speakers",
      services: "TV Repair",
      issue_start_date: "2025-08-05",
      warranty_status: "not sure",
      device_type: "Television",
     issue_photos: [Laptop1, Laptop2, Laptop3,Laptop1],
    },
    {
      brand_name: "LG",
      model_number: "OLED55CX",
      number_of_devices: 1,
      problem_description: "Screen not turning on",
      services: "Power Board Repair",
      device_type: "Television",
      issue_start_date: "2025-08-10",
      warranty_status: "yes",
      issue_photos: [Laptop1, Laptop2, Laptop3,Laptop1],
    }
  ]
  },
  {
    id: 6,
    placedDate: "09 October 2024",
    status: "Pickup completed",
    desc:"delivered",
    invoiceNo: "INV-006",
    person_name: "Amit Verma",
    contact_number: "+91 9811122233",
    pickup_required: "Yes",
    preferred_date: "2025-08-10",
    pickupDate: "2025-08-09",
    preferred_time_slot: "11:00 AM - 1:00 PM",
    notes: "Check cooling fan",
    client_status: "",
    acceptReason:"",
    rejectReasonByManager:"",
    rejectReasonByClient:"",
    timeline: [
       {
        date: "10 Sept 2024",
        time: "11:00 AM",
        status: "Request Received",
        completed: true,
      },
      {
        date: "10 Sept 2024",
        time: "01:00 PM",
        status: "Request accepted",
        completed: true,
      },
      {
        date: "10 Sept 2024",
        time: "02:00 PM",
        status: "Estimation received",
        completed: true,
      },
      {
        date: "12 Sept 2024",
        time: "10:00 AM",
        status: "Estimation approved",
        completed: true,
      },
      {
        date: "13 Sept 2024",
        time: "2:10 PM",
        status:  "Pickup Arranged",
        completed: true,
      },
      {
        date: "3 Sept 2024",
        time: "5:30 PM",
        status: "Pickup Completed",
        completed: true,
      },
      {
        date: "4 Sept 2024",
        time: "3:10 PM",
        status: "Repair In Progress",
        completed: true,
      },
      {
        date: "5 Sept 2024",
        time: "1:45 PM",
        status: "Testing in Progress",
        completed: true,
      },
      {
        date: "6 Sept 2024",
        time: "4:00 PM",
        status: "Final Quality Check",
        completed: true,
      },
      {
        date: "6 Sept 2024",
        time: "4:00 PM",
        status: "Invoice received",
        completed: true,
      },
      
    ],
    address: {
    flat_no: "18",
    building_block: "D",
    floor: "1st",
    building_name: "Tech Park Residency",
    street_name: "OMR Road",
    landmark: "Near Tidel Park",
    city: "Chennai",
    state: "Tamil Nadu",
    pincode: "600113"
  },
  devices: [
    {
      brand_name: "HP",
      model_number: "Pavilion 15",
      number_of_devices: 1,
      problem_description: "Overheating issue",
      services: "Laptop Repair",
      device_type: "Laptop",
      issue_start_date: "2025-08-06",
      warranty_status: "no",
      issue_photos: [Laptop1, Laptop2, Laptop3]
    },
    {
      brand_name: "Dell",
      model_number: "XPS 13",
      number_of_devices: 1,
      problem_description: "Keyboard keys not working",
      services: "Keyboard Replacement",
      device_type: "Laptop",
      issue_start_date: "2025-08-10",
      warranty_status: "no",
      issue_photos: [Laptop1, Laptop2, Laptop3]
    }
  ]
  },
  {
    id: 7,
    placedDate: "09 October 2024",
    status: "Request Refund",
    desc:"cancelled",
    invoiceNo: "INV-007",
    person_name: "Neha Gupta",
    contact_number: "+91 9876501234",
    pickup_required: "No",
    preferred_date: "2025-08-11",
    pickupDate: "",
    preferred_time_slot: "4:00 PM - 6:00 PM",
    notes: "Handle with caution",
    client_status: "",
    acceptReason:"",
    rejectReasonByManager:"",
    rejectReasonByClient:"",
    timeline: [
      {
        date: "1 Sept 2024",
        time: "10:00 AM",
        status: "Pickup requested",
        completed: true,
      },
      {
        date: "2 Sept 2024",
        time: "12:00 PM",
        status: "Pickup completed",
        completed: true,
      },
      {
        date: "3 Sept 2024",
        time: "9:00 AM",
        status: "Repair started",
        completed: true,
      },
      {
        date: "4 Sept 2024",
        time: "2:00 PM",
        status: "User requested refund",
        completed: true,
      },
    ],
    address: {
    flat_no: "21",
    building_block: "E",
    floor: "4th",
    building_name: "River View Apartments",
    street_name: "Park Street",
    landmark: "Near City Center",
    city: "Kolkata",
    state: "West Bengal",
    pincode: "700016"
  },
  devices: [
    {
      brand_name: "Apple",
      model_number: "iPhone 12",
      number_of_devices: 1,
      problem_description: "Battery swelling",
      services: "Phone Battery",
      device_type: "Smartphone",
      issue_start_date: "2025-08-07",
      warranty_status: "not sure",
      issue_photos: [Laptop1, Laptop2, Laptop3]
    },
    {
      brand_name: "Apple",
      model_number: "iPhone SE",
      number_of_devices: 1,
      problem_description: "Not charging properly",
      services: "Charging Port Repair",
      device_type: "Smartphone",
      issue_start_date: "2025-08-10",
      warranty_status: "yes",
      issue_photos: [Laptop1, Laptop2, Laptop3]
    }
  ]
  },
  {
    id: 8,
    placedDate: "09 October 2024",
    status: "Refunded",
    desc:"cancelled",
    invoiceNo: "INV-008",
    person_name: "Rajesh Khanna",
    contact_number: "+91 9123459999",
    pickup_required: "Yes",
    preferred_date: "2025-08-12",
    pickupDate: "2025-08-11",
    preferred_time_slot: "1:00 PM - 3:00 PM",
    notes: "Bring extra cartridges",
    client_status: "rejected",
    acceptReason:"Printer service request approved",
    rejectReasonByManager:"",
    rejectReasonByClient:"Request rejected due to high repair cost estimation",
    timeline_status: "estimation", 
    timeline: [
      {
        date: "2 Sept 2024",
        time: "10:00 AM",
        status: "Pickup requested",
        completed: true,
      },
      {
        date: "3 Sept 2024",
        time: "3:00 PM",
        status: "Repair in progress",
        completed: true,
      },
      {
        date: "4 Sept 2024",
        time: "1:00 PM",
        status: "Refund initiated",
        completed: true,
      },
      {
        date: "5 Sept 2024",
        time: "11:30 AM",
        status: "Refund completed",
        completed: true,
      },
    ],
     address: {
    flat_no: "9",
    building_block: "B",
    floor: "1st",
    building_name: "Pink City Residency",
    street_name: "MI Road",
    landmark: "Near Hawa Mahal",
    city: "Jaipur",
    state: "Rajasthan",
    pincode: "302001"
  },
  devices: [
    {
      brand_name: "Canon",
      model_number: "Pixma G3010",
      number_of_devices: 1,
      problem_description: "Ink leakage",
      services: "Printer Issue",
      device_type: "Printer",
      issue_start_date: "2025-08-08",
      warranty_status: "yes",
      issue_photos: [Laptop1, Mouse1, Mouse2]
    },
    {
      brand_name: "HP",
      model_number: "DeskJet 2131",
      number_of_devices: 1,
      problem_description: "Paper jam",
      services: "Printer Repair",
      device_type: "Printer",
      issue_start_date: "2025-08-10",
      warranty_status: "no",
      issue_photos: [Laptop1, Mouse1, Mouse2]
    }
  ]
  },
  {
    id: 9,
    placedDate: "09 October 2024",
    status: "Person assigned for pickup",
    desc:"inprogress",
    invoiceNo: "INV-004",
    person_name: "Priya Singh",
    contact_number: "+91 9812345678",  
    pickup_required: "Yes",
    preferred_date: "2025-08-08",
    pickupDate: "2025-08-07",
    preferred_time_slot: "3:00 PM - 5:00 PM",
    notes: "Requires urgent service",
    client_status: "pending",
    reason: "",
    acceptReason:"",
    rejectReasonByManager:"",
    rejectReasonByClient:"",
    timeline: [
       {
        date: "10 Sept 2024",
        time: "11:00 AM",
        status: "Request Received",
        completed: true,
      },
      {
        date: "10 Sept 2024",
        time: "01:00 PM",
        status: "Request accepted",
        completed: true,
      },
      {
        date: "10 Sept 2024",
        time: "02:00 PM",
        status: "Estimation received",
        completed: true,
      },
      {
        date: "12 Sept 2024",
        time: "10:00 AM",
        status: "Estimation approved",
        completed: true,
      },
      {
        date: "13 Sept 2024",
        time: "2:10 PM",
        status:  "Pickup Arranged",
        completed: true,
      },
      {
        date: "3 Sept 2024",
        time: "5:30 PM",
        status: "Pickup Completed",
        completed: true,
      },
      {
        date: "4 Sept 2024",
        time: "3:10 PM",
        status: "Repair In Progress",
        completed: true,
      },
      {
        date: "5 Sept 2024",
        time: "1:45 PM",
        status: "Testing in Progress",
        completed: true,
      },
      {
        date: "6 Sept 2024",
        time: "4:00 PM",
        status: "Final Quality Check",
        completed: true,
      },
      {
        date: "6 Sept 2024",
        time: "4:00 PM",
        status: "Invoice received",
        completed: true,
      },
      
    ],
    address: {
    flat_no: "12A",
    building_block: "C",
    floor: "2nd",
    building_name: "Green Heights",
    street_name: "Indiranagar",
    landmark: "Near Metro Station",
    city: "Bangalore",
    state: "Karnataka",
    pincode: "560038"
  },
  devices: [
    {
      brand_name: "LG",
      model_number: "AC1234",
      number_of_devices: 1,
      problem_description: "Not cooling properly",
      services: "AC Maintenance",
      device_type: "Air Conditioner",
      issue_start_date: "2025-08-08",
      warranty_status: "no",
      issue_photos: [DeskTop, LaptopOne, Monitor2]
    },
    {
      brand_name: "Samsung",
      model_number: "AC5678",
      number_of_devices: 1,
      problem_description: "Remote not working",
      services: "Remote Replacement",
      device_type: "Air Conditioner",
      issue_start_date: "2025-08-10",
      warranty_status: "yes",
      issue_photos: [DeskTop, LaptopOne, Monitor2]
    }
  ]
  },
  {
    id: 10,
    placedDate: "09 October 2024",
    status: "Request rejected",
    desc:"inprogress",
    invoiceNo: "INV-004",
    person_name: "Priya Singh",
    contact_number: "+91 9812345678",  
    pickup_required: "Yes",
    preferred_date: "2025-08-08",
    pickupDate: "2025-08-07",
    preferred_time_slot: "3:00 PM - 5:00 PM",
    notes: "Requires urgent service",
    client_status: "pending",
    reason: "",
    acceptReason:"",
    rejectReasonByManager:"AC service request rejected after inspection",
    rejectReasonByClient:"",
    timeline: [
       {
        date: "10 Sept 2024",
        time: "11:00 AM",
        status: "Request Received",
        completed: true,
      },
      {
        date: "10 Sept 2024",
        time: "01:00 PM",
        status: "Request rejected",
        completed: true,
      },
      // {
      //   date: "10 Sept 2024",
      //   time: "02:00 PM",
      //   status: "Estimation received",
      //   completed: true,
      // },
      // {
      //   date: "12 Sept 2024",
      //   time: "10:00 AM",
      //   status: "Estimation approved",
      //   completed: true,
      // },
      // {
      //   date: "13 Sept 2024",
      //   time: "2:10 PM",
      //   status: "Person assigned for pickup",
      //   completed: true,
      // },
      // {
      //   date: "3 Sept 2024",
      //   time: "5:30 PM",
      //   status: "Pickup completed",
      //   completed: true,
      // },
      // {
      //   date: "4 Sept 2024",
      //   time: "3:10 PM",
      //   status: "Repair started",
      //   completed: true,
      // },
      // {
      //   date: "5 Sept 2024",
      //   time: "1:45 PM",
      //   status: "Repair completed",
      //   completed: true,
      // },
      // {
      //   date: "6 Sept 2024",
      //   time: "4:00 PM",
      //   status: "Out for Delivery",
      //   completed: true,
      // },
      
    ],
    address: {
    flat_no: "12A",
    building_block: "C",
    floor: "2nd",
    building_name: "Green Heights",
    street_name: "Indiranagar",
    landmark: "Near Metro Station",
    city: "Bangalore",
    state: "Karnataka",
    pincode: "560038"
  },
  devices: [
    {
      brand_name: "LG",
      model_number: "AC1234",
      number_of_devices: 1,
      problem_description: "Not cooling properly",
      services: "AC Maintenance",
      device_type: "Air Conditioner",
      issue_start_date: "2025-08-08",
      warranty_status: "no",
      issue_photos: [DeskTop, LaptopOne, Monitor2]
    },
    {
      brand_name: "Samsung",
      model_number: "AC5678",
      number_of_devices: 1,
      problem_description: "Remote not working",
      services: "Remote Replacement",
      device_type: "Air Conditioner",
      issue_start_date: "2025-08-10",
      warranty_status: "yes",
      issue_photos: [DeskTop, LaptopOne, Monitor2]
    }
  ]
  },
];
